// extracted by mini-css-extract-plugin
export default {"bathrooms":"styles_bathrooms__1G+6B","to":"styles_to__sxc+y"};